var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8326 0.167384C15.9923 0.327064 16.043 0.565805 15.9619 0.776575L10.2476 15.6337C10.165 15.8486 9.96141 15.9929 9.73126 15.9997C9.50112 16.0066 9.28935 15.8746 9.19407 15.665L6.75705 10.3036L10.2446 6.81604C10.5375 6.52314 10.5375 6.04827 10.2446 5.75538C9.95171 5.46248 9.47684 5.46248 9.18394 5.75538L5.69638 9.24294L0.334971 6.80593C0.125361 6.71066 -0.0065895 6.49889 0.000253996 6.26874C0.00709752 6.03859 0.151398 5.83504 0.366299 5.75238L15.2234 0.0381047C15.4342 -0.0429606 15.6729 0.0077037 15.8326 0.167384Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendFilled);
export default __webpack_public_path__ + "static/media/send-filled.8d101ee33f5383c77f4a35f97071a39a.svg";
export { ForwardRef as ReactComponent };